export const truncate = (words, maxLength) => {
  return words.length > maxLength ? `${words.slice(0, maxLength)}...` : words
}